module.exports = __webpack_public_path__ + "assets/jqplot.8ba542ec.svg";